import React, { useEffect, useState } from 'react'
import { Box, ResponsiveBox, ImageLoader } from '@usap/uicomponents'
import { Title, StarCount } from '@usap/widgets'

export default function NewProductsCard({
  data,
  index,
  getReviews,
  Link,
  isBot,
  formatBrand,
}) {
  const {
    id,
    sku,
    brand,
    pricing,
    productUri,
    productImageUrl,
    skuTitle,
  } = data

  const [reviews, setReviews] = useState({
    avgRating: '',
    reviewCount: '',
  })
  const { avgRating, reviewCount } = reviews

  useEffect(() => {
    let mounted = true
    getReviews(id).then(response => {
      if (!mounted) return
      setReviews(response)
    })
    return () => {
      mounted = false
    }
  }, [id])

  const length = 75
  const title = `${sku}-${skuTitle}`
  const truncatedTitle = title.length > length ? `${title.substring(0, length)}...` : title

  return (
    <ResponsiveBox
      id={index}
      fxStyle={{
        other: { minWidth: '250px' },
        large: { width: '20%' },
      }}
    >
      <Box pad="small" background="white">
        <Link style={{ textDecoration: 'none' }} to={productUri}>
          <ResponsiveBox
            justify="center"
            align="center"
            fxPad={{ other: { horizontal: 'small' }, large: 'medium' }}
            margin={{ bottom: 'small' }}
            height="200px"
            width="200px"
          >
            <ImageLoader
              height="100%"
              width="100%"
              layout="fixed"
              fit="contain"
              source={productImageUrl}
              alt={`${sku}-${skuTitle}`}
              cloudinaryParams="h_200,w_200"
              isBot={isBot}
            />
          </ResponsiveBox>
        </Link>

        <Box>
          <Title size="20px" color="dark-2" weight="bold" label={formatBrand(brand)} />
        </Box>

        <Box width="100%" style={{ minHeight: 60 }}>
          <Link style={{ textDecoration: 'none' }} to={productUri}>
            <Title
              size="small"
              color="dark-2"
              weight={400}
              dangerouslySetInnerHTML={{
                __html: truncatedTitle,
              }}
            />
          </Link>
        </Box>

        <Box>
          <Title size="xsmall" color="dark-1" label={`Part No: ${data.sku}`} />
        </Box>

        {reviewCount ? (
          <Box
            direction="row"
            align="start"
            margin={{ bottom: 'small' }}
            wrap
          >
            {avgRating ? <StarCount ratings={avgRating} /> : null}
            <Title
              size="small"
              margin={{ horizontal: 'small' }}
              label={`(${reviewCount} Reviews)`}
            />
          </Box>
        ) : (
          <Box height="28px" />
        )}

        <Box>
          <Title
            size="20px"
            color="dark-2"
            weight="bold"
            label={`$${pricing}`}
          />
        </Box>
      </Box>
    </ResponsiveBox>
  )
}
